import { MyConfirmRequest } from './myRequestResponsibilityApprove';

require('./myRequestResponsibilityApprove.scss');

export const myConfirmRequestComponent = {
  template: require('./myRequestResponsibilityApprove.html'),
  controllerAs: 'ctrl',
  controller: MyConfirmRequest,
};
